module.exports = __webpack_public_path__ + "media/images/riders/CONNOR_FEARON-78811f319919456aff480139a2e82f8c.png";